(() => {
  const CHECKOUT_BUTTON_SELECTOR = [
    '#CartDrawer #checkout-submit',
    '#CartDrawer button[name="checkout"][form="CartDrawer-Form"]',
    '.bss-checkout[bss-b2b-cart-trigger-added]'
  ].join(', ');
  const MODAL_SELECTOR = 'x-modal#checkout-modal';

  function getCheckoutButton(event) {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest(CHECKOUT_BUTTON_SELECTOR);

    if (button) return button;

    return event.composedPath().find((element) =>
      element instanceof Element && element.matches(CHECKOUT_BUTTON_SELECTOR)
    );
  }

  function openCheckoutModal(event) {
    const modal = document.querySelector(MODAL_SELECTOR);
    if (!modal) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    if (typeof modal.open === 'function') modal.open();
    else modal.setAttribute('open', '');

    return true;
  }

  function handleCheckoutClick(event) {
    const button = getCheckoutButton(event);
    if (!button || button.closest(MODAL_SELECTOR)) return;

    openCheckoutModal(event);
  }

  function handleCartSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'CartDrawer-Form') return;

    openCheckoutModal(event);
  }

  // Capture on window runs before document-level handlers added by checkout apps.
  window.addEventListener('click', handleCheckoutClick, true);
  window.addEventListener('submit', handleCartSubmit, true);
})();
